var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_15024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3115 7.36035C24.7953 4.67217 24.5248 2.63202 23.3812 1.82128C23 1.55104 22.5429 1.43278 22.0286 1.4541C19.2511 1.56921 14.7694 5.74412 11.1078 11.8994C6.76805 19.1946 5.22583 26.5058 7.66551 28.2353C8.82359 29.0564 10.669 28.4744 12.7538 26.8525",
    stroke: "white",
    strokeWidth: 1.14504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5358 19.2883C28.5956 18.416 29.8622 17.222 29.928 15.8508C30.0802 12.6795 23.7582 9.74354 15.8011 9.28829C15.0551 9.24562 14.3216 9.22316 13.604 9.22579C6.66803 9.25128 1.25394 11.3284 1.11597 14.2024C1.05027 15.5709 2.19242 16.898 4.15032 17.9992",
    stroke: "white",
    strokeWidth: 1.14504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5545 2.63481C12.1452 1.35834 10.8235 0.672868 9.76159 0.759814C9.47885 0.782963 9.21736 0.859029 8.97437 0.994189C6.38245 2.4359 7.21047 9.89222 10.8279 17.6426C14.4453 25.393 19.4788 30.5062 22.0707 29.0645C24.5634 27.678 23.8906 20.7301 20.618 13.3067",
    stroke: "white",
    strokeWidth: 1.14504,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3336 15.2498C17.3336 15.747 17.1526 16.2239 16.8305 16.5756C16.5084 16.9272 16.0715 17.1248 15.616 17.1248C15.1605 17.1248 14.7236 16.9272 14.4015 16.5756C14.0794 16.2239 13.8984 15.747 13.8984 15.2498C13.8984 14.7525 14.0794 14.2756 14.4015 13.9239C14.7236 13.5723 15.1605 13.3748 15.616 13.3748C16.0715 13.3748 16.5084 13.5723 16.8305 13.9239C17.1526 14.2756 17.3336 14.7525 17.3336 15.2498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_15024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtom);
export default __webpack_public_path__ + "static/media/atom.b8c4615e8231840fa509a8fea526d3cf.svg";
export { ForwardRef as ReactComponent };